import React, { useContext } from "react";
import styled, { keyframes } from "styled-components";

import { CurrentThemeContext } from "./ThemeContextWrapper";
import BaseURL from "./../Unit/data/images/Hosting-BaseURL";

const springBlossom1 = `${BaseURL}/background/particles/blossom1.gif`;
const springBlossom2 = `${BaseURL}/background/particles/blossom2.gif`;
const springBlossom3 = `${BaseURL}/background/particles/blossom3.gif`;
const springBlossom4 = `${BaseURL}/background/particles/blossom4.gif`;
const springBlossom5 = `${BaseURL}/background/particles/blossom5.gif`;
const springBlossom6 = `${BaseURL}/background/particles/blossom6.gif`;
const springBlossom7 = `${BaseURL}/background/particles/blossom7.gif`;

const autumnLeaf1 = `${BaseURL}/background/particles/Leaf1.gif`;
const autumnLeaf2 = `${BaseURL}/background/particles/Leaf2.gif`;
const autumnLeaf3 = `${BaseURL}/background/particles/Leaf3.gif`;
const autumnLeaf4 = `${BaseURL}/background/particles/Leaf4.gif`;
const autumnLeaf5 = `${BaseURL}/background/particles/Leaf5.gif`;
const autumnLeaf6 = `${BaseURL}/background/particles/Leaf6.gif`;
const autumnLeaf7 = `${BaseURL}/background/particles/Leaf7.gif`;
const autumnLeaf8 = `${BaseURL}/background/particles/Leaf8.gif`;
const autumnLeaf9 = `${BaseURL}/background/particles/Leaf9.gif`;

export function getRandomNumber(rangeMax, rangeMin) {
    return Math.floor(Math.random() * (rangeMax - rangeMin + 1)) + rangeMin;
}

const snowArray = [];
const leavesArray = [];
const petalsArray = [];
// const firefliesArray = [];

const backgroundSnowArray = [];
const backgroundLeavesArray = [];
const backgroundPetalsArray = [];

const backgroundZIndex = 2;
const foreZIndex = 100;

const snowDefaults = {
    count: 35,
    durationMax: 10,
    durationMin: 5,
    delayMax: 20,
    delayMin: 10,
    sizeMax: 24,
    sizeMin: 6,
};

const backgroundSnowDefaults = {
    count: 40,
    durationMax: 20,
    durationMin: 15,
    delayMax: 25,
    delayMin: 10,
    sizeMax: 18,
    sizeMin: 3,
};

const leavesDefaults = {
    count: 15,
    durationMax: 15,
    durationMin: 10,
    delayMax: 20,
    delayMin: 10,
    sizeMax: 12,
    sizeMin: 6,
};

const backgroundLeavesDefaults = {
    count: 20,
    durationMax: 30,
    durationMin: 20,
    delayMax: 25,
    delayMin: 10,
    sizeMax: 15,
    sizeMin: 10,
};

const petalsDefaults = {
    count: 30,
    durationMax: 15,
    durationMin: 10,
    delayMax: 20,
    delayMin: 10,
    sizeMax: 12,
    sizeMin: 6,
};

const backgroundPetalsDefaults = {
    count: 35,
    durationMax: 30,
    durationMin: 15,
    delayMax: 25,
    delayMin: 10,
    sizeMax: 8,
    sizeMin: 4,
};

// const numOfFireflies = 20;
// const fireflyDurationMax = 10;
// const fireflyDurationMin = 5;
// const fireflyDelayMax = 30;
// const fireflyDelayMin = 10;
// const fireflySizeMax = 15;
// const fireflySizeMin = 8;

for (let i = 0; i < snowDefaults.count; i += 1) {
    snowArray.push({
        key: i,
        delay: getRandomNumber(snowDefaults.delayMax, snowDefaults.delayMin),
        duration: getRandomNumber(snowDefaults.durationMax, snowDefaults.durationMin),
        left: getRandomNumber(100, 0),
        content: getRandomNumber(50, 1),
        size: getRandomNumber(snowDefaults.sizeMax, snowDefaults.sizeMin),
        zIndex: foreZIndex,
    });
}

for (let i = 0; i < backgroundSnowDefaults.count; i += 1) {
    backgroundSnowArray.push({
        key: `back-${i}`,
        delay: getRandomNumber(backgroundSnowDefaults.delayMax, backgroundSnowDefaults.delayMin),
        duration: getRandomNumber(backgroundSnowDefaults.durationMax, backgroundSnowDefaults.durationMin),
        left: getRandomNumber(100, 0),
        content: 1,
        size: getRandomNumber(backgroundSnowDefaults.sizeMax, backgroundSnowDefaults.sizeMin),
        zIndex: backgroundZIndex,
    });
}

for (let i = 0; i < leavesDefaults.count; i += 1) {
    leavesArray.push({
        key: i,
        delay: getRandomNumber(leavesDefaults.delayMax, leavesDefaults.delayMin),
        duration: getRandomNumber(leavesDefaults.durationMax, leavesDefaults.durationMin),
        left: getRandomNumber(100, 0),
        content: getRandomNumber(30, 1),
        size: getRandomNumber(leavesDefaults.sizeMax, leavesDefaults.sizeMin),
        zIndex: foreZIndex,
    });
}

for (let i = 0; i < backgroundLeavesDefaults.count; i += 1) {
    backgroundLeavesArray.push({
        key: `back-${i}`,
        delay: getRandomNumber(backgroundLeavesDefaults.delayMax, backgroundLeavesDefaults.delayMin),
        duration: getRandomNumber(backgroundLeavesDefaults.durationMax, backgroundLeavesDefaults.durationMin),
        left: getRandomNumber(100, 0),
        content: 30,
        size: getRandomNumber(backgroundLeavesDefaults.sizeMax, backgroundLeavesDefaults.sizeMin),
        zIndex: backgroundZIndex,
    });
}

for (let i = 0; i < petalsDefaults.count; i += 1) {
    petalsArray.push({
        key: i,
        delay: getRandomNumber(petalsDefaults.delayMax, petalsDefaults.delayMin),
        duration: getRandomNumber(petalsDefaults.durationMax, petalsDefaults.durationMin),
        left: getRandomNumber(100, 0),
        content: getRandomNumber(20, 1),
        size: getRandomNumber(petalsDefaults.sizeMax, petalsDefaults.sizeMin),
        zIndex: foreZIndex,
    });
}

for (let i = 0; i < backgroundPetalsDefaults.count; i += 1) {
    backgroundPetalsArray.push({
        key: `back-${i}`,
        delay: getRandomNumber(backgroundPetalsDefaults.delayMax, backgroundPetalsDefaults.delayMin),
        duration: getRandomNumber(backgroundPetalsDefaults.durationMax, backgroundPetalsDefaults.durationMin),
        left: getRandomNumber(100, 0),
        content: getRandomNumber(20, 1),
        size: getRandomNumber(backgroundPetalsDefaults.sizeMax, backgroundPetalsDefaults.sizeMin),
        zIndex: backgroundZIndex,
    });
}

// for (let i = 0; i < numOfFireflies; i += 1) {
//     firefliesArray.push({
//         key: i,
//         delay: getRandomNumber(fireflyDelayMax, fireflyDelayMin),
//         duration: getRandomNumber(fireflyDurationMax, fireflyDurationMin),
//         left: getRandomNumber(100, 0),
//         top: getRandomNumber(100, 0),
//         content: getRandomNumber(20, 1),
//         size: getRandomNumber(fireflySizeMax, fireflySizeMin),
//     });
// }

const snowfall = keyframes`
    0% {
        transform: rotate(0deg);
        transform: translateX(0%);
        top: -10%;
    }

    25% {
        transform: translateX(-100%);
    }

    50% {
        transform: rotate(180deg);
        transform: translateX(0%);
    }

    75% {
        transform: translateX(0%);
        opacity: 1;
    }

    100% {
        transform: rotate(360deg);
        top: 100%;
        opacity: 0;
    }
`;

const windySnowfall = keyframes`
    0% {
        transform: rotate(0deg);
        transform: translateX(-2000%);
        top: -10%;
    }

    25% {
        transform: translateX(0%);
    }

    50% {
        transform: rotate(180deg);
        transform: translateX(1000%);
    }

    75% {
        transform: translateX(3000%);
    }

    90% {
        opacity: 1;
    }

    100% {
        transform: translateX(5000%);
        transform: rotate(360deg);
        top: 110%;
        opacity: 0;
    }
`;

const petalfall = keyframes`
    0% {
        transform: rotate(0deg);
        transform: translateX(-4000%);
        top: -10%;
    }

    25% {
        transform: translateX(0%);
    }

    50% {
        transform: rotate(180deg);
        transform: translateX(2000%);
    }

    75% {
        transform: translateX(4000%);
    }

    90% {
        opacity: 1;
    }

    100% {
        transform: translateX(9000%);
        transform: rotate(360deg);
        top: 110%;
        opacity: 0;
    }
`;

// const firefly = keyframes`
//     0% {
//         opacity: 0;
//     }

//     5% {
//         transform: translateX(-400%);
//         transform: translateY(10%);

//     }

//     25% {
//         transform: translateX(0%);
//         transform: translateY(10%);
//     }

//     50% {
//         transform: translateX(400%);
//         transform: translateY(10%);
//         opacity: 1;
//     }

//     75% {
//         transform: translateX(200%);
//         transform: translateY(10%);
//         opacity: 1;
//     }

//     100% {
//         transform: translateX(-100%);
//         transform: translateY(10%);
//         opacity: 0;
//     }
// `;

const SeasonalSpan = styled.span`
    position: absolute;
    z-index: ${props => props.zIndex};

    left: ${props => props.left}%;
    top: -10%;

    animation-delay: ${props => props.delay}s;
    animation-duration: ${props => props.duration}s;
    animation-iteration-count: infinite;
`;

SeasonalSpan.displayName = "SeasonalSpan";

const Snow = styled(SeasonalSpan)`
    color: white;

    animation-name: ${props => props.windy ? windySnowfall : snowfall};

    &:after {
        content: ${props => {
        switch (props.content) {
            case 3:
                return '"❅"';
            case 17:
                return '"❆"';
            case 31:
                return '"❄"';
            default:
                return '"•"';
        }
    }};

        font-size: ${props => props.size}px;
    }
`;

const Leaf = styled(SeasonalSpan)`
    color: #401500;

    animation-name: ${petalfall};

    ${props => {
        switch (props.content) {
            case 1:
            case 10:
            case 19:
                return `
                    width: 25px;
                    height: 25px;
                    background: url(${autumnLeaf1});
                `;

            case 2:
            case 11:
            case 20:
                return `
                    width: 22px;
                    height: 26px;
                    background: url(${autumnLeaf2});
                `;

            case 3:
            case 12:
            case 21:
                return `
                    width: 50px;
                    height: 50px;
                    background: url(${autumnLeaf3});
                `;

            case 4:
            case 13:
            case 22:
                return `
                    width: 50px;
                    height: 50px;
                    background: url(${autumnLeaf4});
                `;

            case 5:
            case 14:
            case 23:
                return `
                    width: 25px;
                    height: 25px;
                    background: url(${autumnLeaf5});
                `;

            case 6:
            case 15:
            case 24:
                return `
                    width: 20px;
                    height: 20px;
                    background: url(${autumnLeaf6});
                `;

            case 7:
            case 16:
            case 25:
                return `
                    width: 22px;
                    height: 26px;
                    background: url(${autumnLeaf7});
                `;

            case 8:
            case 17:
            case 26:
                return `
                    width: 50px;
                    height: 50px;
                    background: url(${autumnLeaf8});
                `;

            case 9:
            case 18:
            case 27:
                return `
                    width: 20px;
                    height: 20px;
                    background: url(${autumnLeaf9});
                `;

            default:
                return `&:after { content: "•"; font-size: ${props => props.size}px; }`;
        }
    }}

    font-size: ${props => props.size}px;

`;

const Petal = styled(SeasonalSpan)`
    color: pink;

    animation-name: ${petalfall};

    width: 10px;
    height: 10px;

    ${props => {
        switch (props.content) {
            case 1:
            case 8:
            case 15:
                return `background: url(${springBlossom1});`;

            case 2:
            case 9:
            case 16:
                return `background: url(${springBlossom2});`;

            case 3:
            case 10:
            case 17:
                return `background: url(${springBlossom3});`;

            case 4:
            case 11:
            case 18:
                return `background: url(${springBlossom4});`;

            case 5:
            case 12:
            case 19:
                return `background: url(${springBlossom5});`;

            case 6:
            case 13:
                return `background: url(${springBlossom6});`;

            case 7:
            case 14:
                return `background: url(${springBlossom7});`;

            default:
                return `&:after { content: "•"; font-size: ${props => props.size}px; }`;
        }
    }}
`;

// const Firefly = styled.span`
//     position: absolute;
//     color: lightyellow;
//     z-index: 100;
//     opacity: 0;

//     animation-name: ${firefly};
//     animation-delay: ${props => props.delay}s;

//     animation-duration: ${props => props.duration}s;
//     animation-iteration-count: infinite;
//     left: ${props => props.left}%;
//     top: ${props => props.top}%;

//     &:after {
//         content: ${props => {
//             switch(props.content) {
//                 case 3:
//                 case 17:
//                 case 31:
//                     return '"✶"';
//                 default:
//                     return '"•"';
//             }
//         }};

//         font-size: ${props => props.size}px;
//     }
// `;

const SeasonWrapper = styled.div`
    position: fixed;
    z-index: 2;
    top: 0;
    left: 0;
    width: 96vw;
    height: 100vh;
    margin-left: 1.5vw;
    pointer-events: none;
`;

SeasonWrapper.displayName = "SeasonWrapper";

function SeasonalFlavor({ background = false }) {
    const { currentTheme } = useContext(CurrentThemeContext);

    let particlesEl = [];

    if (currentTheme === "winter") {
        const windy = Math.random() > 0;

        particlesEl = (background ? backgroundSnowArray : snowArray).map(snowflake => (
            <Snow
                key={`snow-${snowflake.key}`}
                delay={snowflake.delay}
                duration={snowflake.duration}
                left={snowflake.left}
                content={snowflake.content}
                size={snowflake.size}
                windy={windy}
                zIndex={snowflake.zIndex}
            />
        ));
    }

    if (currentTheme === "autumn") {
        particlesEl = (background ? backgroundLeavesArray : leavesArray).map(leaf => (
            <Leaf
                key={`leaf-${leaf.key}`}
                delay={leaf.delay}
                duration={leaf.duration}
                left={leaf.left}
                content={leaf.content}
                size={leaf.size}
                zIndex={leaf.zIndex}
            />
        ));
    }

    if (currentTheme === "spring") {
        particlesEl = (background ? backgroundPetalsArray : petalsArray).map(petal => (
            <Petal
                key={`petal-${petal.key}`}
                delay={petal.delay}
                duration={petal.duration}
                left={petal.left}
                content={petal.content}
                size={petal.size}
                zIndex={petal.zIndex}
            />
        ));
    }

    // if (currentTheme === "summer") {
    //     particlesEl = firefliesArray.map(firefly => (
    //         <Firefly
    //             key={`firefly-${firefly.key}`}
    //             delay={firefly.delay}
    //             duration={firefly.duration}
    //             left={firefly.left}
    //             top={firefly.top}
    //             content={firefly.content}
    //             size={firefly.size}
    //         />
    //     ));
    // }

    return (
        <SeasonWrapper>
            {particlesEl}
        </SeasonWrapper>
    );
}

export default SeasonalFlavor;
